import { render, staticRenderFns } from "./myOrganisationDevicesTables.vue?vue&type=template&id=275abc7a&scoped=true&"
import script from "./myOrganisationDevicesTables.vue?vue&type=script&lang=js&"
export * from "./myOrganisationDevicesTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275abc7a",
  null
  
)

export default component.exports